var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",style:({'height':'calc(80% - 25px)','width':_vm.width,'position': 'absolute','display': 'flex'})})}
var staticRenderFns = []

export { render, staticRenderFns }